export * from "./loggerMiddleware";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxvQkFBb0IsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL2xvZ2dlck1pZGRsZXdhcmVcIjtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@aws-sdk/middleware-logger/dist/es/index.js
// module id = 854
// module chunks = 0